/**
 * Validate an email address string.
 *
 * ⚠️ As ever, email validation is tricky (impossible, really), but it's often helpful to try.
 *
 * @returns {boolean} true if the email address **_looks_** valid
 * @see https://stackoverflow.com/a/46181
 */
export function isValidEmail(emailAddress: string): boolean {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    emailAddress,
  )
}

/**
 * The domain an address belongs to, lower-cased, or an empty string if it
 * doesn't look like an address at all.
 *
 * Deliberately lenient - it's for grouping addresses by the firm behind them,
 * not for deciding whether one is deliverable. Use `isValidEmail` for that.
 */
export function emailDomain(emailAddress: string): string {
  return emailAddress.split('@')[1]?.trim().toLowerCase() ?? ''
}
